import { Stack, Alert, AlertTitle, AlertMessage, AlertIcon } from '@tumelo/designsystem'
import React, { createContext, use } from 'react'
import { Privileges } from '../proto/tumelo/stewardshipbff/v1/user'
import { useFetchPrivilegesSWR } from './features/privileges/useFetchPrivilegesSWR'

const PrivilegesContext = createContext<Privileges | null>(null)

export const PrivilegesContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data: privilegesResponse, isLoading, error } = useFetchPrivilegesSWR()

  if (isLoading) {
    return null
  }

  if (error || !privilegesResponse) {
    return (
      <Stack mt="2.4rem" alignItems="center">
        <Alert variant="warning">
          <AlertTitle icon={<AlertIcon />}>Unable to load permissions</AlertTitle>
          <AlertMessage>
            We&apos;re unable to verify your permissions at this time. Please refresh the page or try again later.
          </AlertMessage>
        </Alert>
      </Stack>
    )
  }

  return <PrivilegesContext.Provider value={privilegesResponse}>{children}</PrivilegesContext.Provider>
}

export const usePrivileges = (): Privileges | null => {
  return use(PrivilegesContext)
}
